jQuery(document).ready(function(){	
	
	jQuery('.testimonial-slider').slick({
	  	slidesToShow: 1,
		infinite: true,
		slidesToScroll: 1,
		dots: false,
		autoplay: false,
		autoplaySpeed: 10000,
		draggable: false,
		fade: true,
		arrows: false,
		adaptiveHeight: true,
		responsive: [
			{
			  breakpoint: 760,
			  settings: {
		      	slidesToShow: 1
		      	//adaptiveHeight: true
			  }
			}
		]			
	});	
});

jQuery('button.previous').click(function(){
	
	jQuery('.testimonial-slider').slick('slickPrev');
	
});

jQuery('button.next').click(function(){
	
	jQuery('.testimonial-slider').slick('slickNext');
	
});